import React, { useRef, useState } from "react";
import { TextField, Button, Typography, CircularProgress, Autocomplete, Checkbox, ListItemText } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Send } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { addCampUrls, getCampUrls } from "../../redux/features/clicksSlice";
import { Switch } from "@mui/material";
import { clearTextFields } from "../../utils/clearTextFields";

const DEVICE_TYPE_OPTIONS = ["Mobile", "Desktop"];

const AddRow = ({ setShowInput, codeType, siteId, duplicateData }) => {
  const dispatch = useDispatch();
  
  const [store_ID, setStore_id] = useState(duplicateData?.store_id || "");
  const [link, setLink] = useState(duplicateData?.link || "");
  const [link2, setLink2] = useState(duplicateData?.link2 || "");
  const [targeted_countries, setTargetedCountries] = useState(duplicateData?.targeted_countries || "");
  const [device_type, setDeviceType] = useState(duplicateData?.device_type ? duplicateData.device_type.split(",") : []);
  const [ratio, setRatio] = useState(duplicateData?.ratio || "");
  const [type, setType] = useState(duplicateData?.type || "");
  const [comments, setComments] = useState(duplicateData?.comments || "");
  const [checked, setChecked] = useState(duplicateData ? duplicateData.active == 1 : true);
  const [active, setActive] = useState(duplicateData ? (duplicateData.active == 1 ? 1 : 0) : 1);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setShowInput(false);
    
    if (!store_ID) {
      toast.error("Please select a Store ID");
      return;
    }

    // -------Adding inputvalues to form data OBJ-----//
    const formData = {
      store_id: store_ID,
      link: link,
      link2: link2,
      targeted_countries: targeted_countries,
      device_type: device_type.join(","),
      ratio: ratio,
      type: type,
      active: active,
      comments: comments
    };

    // -------Adding inputvalues to form data OBJ-----//

    setIsLoading(true);
    try {
      dispatch(addCampUrls(formData));
      dispatch(getCampUrls());
      toast.success("Added Successfully!", {
        position: "top-center",
        autoClose: 3000,
      });
      setStore_id("");
      setLink("");
      setLink2("");
      setTargetedCountries("");
      setDeviceType([]);
      setRatio("");
      setType("");
      setComments("");
      setChecked(true);
      setActive(1);
    } catch (error) {
      toast.error("Something went wrong", {
        position: "top-center",
        autoClose: 3000,
      });
      console.error("Error creating row:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSwitch = (event) => {
    setChecked(event.target.checked);
    setActive(event.target.checked ? 1 : 0);
  };

  // Find the selected store object for Autocomplete value
  const selectedStore = siteId?.find(s => s.id === store_ID) || null;

  return (
    <>
      <Typography variant="h4" sx={{ paddingLeft: "20px" }}>
        Campaign Links
      </Typography>
      <form
        onSubmit={handleSubmit}
        encType="multipart/form-data"
        style={{ padding: "20px", display: "flex", flexDirection: "column" }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          <FormControl sx={{ width: "48%" }}>
            <Autocomplete
              options={siteId || []}
              getOptionLabel={(option) => `${option.id}-${option.site_name}`}
              value={selectedStore}
              onChange={(event, newValue) => {
                setStore_id(newValue ? newValue.id : "");
              }}
              renderInput={(params) => (
                <TextField {...params} label="Store ID" required={!store_ID} />
              )}
            />
          </FormControl>

          <TextField
            label="Link"
            required
            value={link}
            onChange={(e) => setLink(e.target.value)}
            sx={{ width: "48%" }}
          />
          <TextField
            label="Link2"
            value={link2}
            onChange={(e) => setLink2(e.target.value)}
            sx={{ width: "48%" }}
          />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          <TextField
            label="Ratio"
            required
            value={ratio}
            onChange={(e) => setRatio(e.target.value)}
            sx={{ width: "48%" }}
            type="number"
          />
          <FormControl sx={{ width: "48%" }}>
            <InputLabel id="demo-simple-select-label">Type</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="Type"
              value={type}
              onChange={(e) => setType(e.target.value)}
              required
            >
              {codeType?.map((item) => (
                <MenuItem key={item.type_id} value={item.type_id}>
                  {item.type_id}-{item.description}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          <TextField
            label="Targeted Countries"
            value={targeted_countries}
            onChange={(e) => setTargetedCountries(e.target.value)}
            sx={{ width: "48%" }}
          />
          <FormControl sx={{ width: "48%" }}>
            <InputLabel id="device-type-select-label">Device Type</InputLabel>
            <Select
              labelId="device-type-select-label"
              label="Device Type"
              multiple
              value={device_type}
              onChange={(e) => {
                const value = e.target.value;
                setDeviceType(typeof value === "string" ? value.split(",") : value);
              }}
              renderValue={(selected) => selected.join(", ")}
            >
              {DEVICE_TYPE_OPTIONS.map((option) => (
                <MenuItem key={option} value={option}>
                  <Checkbox checked={device_type.indexOf(option) > -1} />
                  <ListItemText primary={option} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          <div
            style={{
              gap: "5%",
              marginBottom: "5px",
              width: "48%",
              border: "1px solid #bfbfbf",
              borderRadius: "3px",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <p style={{ margin: "0", marginLeft: "10px" }}>Active-{active}</p>
            <Switch
              checked={checked}
              onChange={handleSwitch}
              inputProps={{ "aria-label": "controlled" }}
            />
          </div>
          <TextField
            label="Comments"
            value={comments}
            onChange={(e) => setComments(e.target.value)}
            sx={{ width: "48%" }}
          />
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Button
            sx={{ width: "10%", textAlign: "center" }}
            type="submit"
            variant="contained"
            color="success"
            startIcon={
              isLoading ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                <Send />
              )
            }
            disabled={isLoading}
          >
            {isLoading ? "Adding..." : "Add"}
          </Button>
        </div>
      </form>
    </>
  );
};

export default AddRow;
